import {
  extendTheme,
  withDefaultColorScheme,
  ChakraTheme,
  withDefaultVariant,
} from "@chakra-ui/react";

import foundations from "./foundations";
import components from "./components";
import textStyles from "./textStyles";

const overrides: Partial<ChakraTheme> = {
  ...foundations,
  textStyles,
  components,
};
export default extendTheme(
  overrides,
  withDefaultColorScheme({ colorScheme: "navy" }),
  withDefaultVariant({ variant: "primary", components: ["Button"] })
);
